module.exports = __webpack_public_path__ + "img/contact.eb3c8e55.jpg";